var social_tick_size = 42;
var right_social_buffer_is_shown = false;
var left_social_buffer_is_shown = false;
var max_social_scroll_value = 0;
$(document).ready(function() {
	
	//This event is triggered ***after*** the animation for showing the tab has finished
	$('#staffProfileTab.nav-tabs a.nav-link').on('shown.bs.tab', function(event){
		var tab_just_shown = $(this);
		var content_area_shown_id = tab_just_shown.prop('hash');
		var associated_content_area = $(content_area_shown_id);
	    //add ellipsis to expert lebels
		associated_content_area.find('.expertise_list_item_label').ellipsis({
			lines: 2,      
			ellipClass: 'ellip',
			responsive: true
		});
	});
	
	var $guardedEl_further_info_detail_ = $("#further_info_detail .further_detail_inner");
	if ($guardedEl_further_info_detail_.length) {
	    var div_height = $guardedEl_further_info_detail_.height();
	} else {
	    console.warn('guard-jquery-calls: $("#further_info_detail .further_detail_inner") not found, skipping.');
	}
	if (div_height > 210) {
		$("div #further_info_detail").addClass('fixedHeight');
	} else {
		$("div #further_info_detail").removeClass('fixedHeight');
		$("div #further_info_read_more").hide();
	}
	/* Click event to show or hide further information.*/
	$(document).on('keyup', '.further_info_read_more_button',function(e){
	    if(e.which==13 || e.which==32) {
	    	$(this).closest('.further_info_read_more_button').click();
	    	
	    }
	});
	
	$('body').on('click', '.further_info_read_more a', function() {
		var ele_clicked = $(this);
		var div_container = $("#further_info_detail");
		var transition_delay = 1000;
		
		if (div_container.hasClass("fixedHeight")) {
			linkText = 'Read less';
			$('#further_info_detail').removeClass("fixedHeight", transition_delay);
		} else {
			linkText = 'Read more';
			$('#further_info_detail').addClass("fixedHeight", transition_delay);
		}
		ele_clicked.text(linkText);
	});
	
	//Click event to show phone number.
	$('.profile_contact_phone a').on('click', function() {
		var ele_clicked = $(this);
		var phone_number = $('.profile_phone_number').val();
		ele_clicked.html(phone_number + '<span><i class="fa fa-phone"></i></span>');		
	});
	
	var left_buffer_is_shown = false;
	$('.tab_navigation_container').on('scroll', function() {
		var nav_container_scrolling = $(this);
		var current_scroll_left_value = nav_container_scrolling.scrollLeft();
		var left_buffer_element = nav_container_scrolling.children('.left_buffer');
		
		if(!left_buffer_is_shown && current_scroll_left_value > 0) {
			left_buffer_is_shown = true;
			left_buffer_element.fadeIn();
		} else if(left_buffer_is_shown && current_scroll_left_value === 0) {
			left_buffer_is_shown = false;
			left_buffer_element.fadeOut();
		}
	});
	
	adjustWidthForTabContainer();
	adjustSocialMediaContainerWidth();
	
	$('.profile_contact_phone a').on('click', function() {
		var ele_clicked = $(this);
		var phone_number = $('.profile_phone_number').val();
		ele_clicked.html(phone_number + '<span><i class="fa fa-phone"></i></span>');
		//ele_clicked.text(phone_number);
		
	});
	$('.left_block').on('click', function() {
		scrollSocialMediaListOneTick("left");
	});
	$('.right_block').on('click', function() {
		scrollSocialMediaListOneTick("right");
	});
	
	
	$('.social_media_container').on('scroll', function() {
		var social_container_scrolling = $(this);
		var social_container_scrolling_width = social_container_scrolling.width();
		var current_scroll_left_value = social_container_scrolling.scrollLeft();
		var left_social_buffer_element = social_container_scrolling.children('.left_block');
		var right_social_buffer_element = social_container_scrolling.children('.right_block');

		if(right_social_buffer_is_shown && current_scroll_left_value === max_social_scroll_value) {
			right_social_buffer_element.fadeOut(function() {
				right_social_buffer_is_shown = false;
		    });
			
		} else if (!right_social_buffer_is_shown && current_scroll_left_value < max_social_scroll_value){
			right_social_buffer_element.fadeIn();
			right_social_buffer_is_shown = true;
		}
		if(!left_social_buffer_is_shown && current_scroll_left_value > 0) {
			left_social_buffer_is_shown = true;
			left_social_buffer_element.fadeIn();
		} else if(left_social_buffer_is_shown && current_scroll_left_value === 0) {
			left_social_buffer_is_shown = false;
			left_social_buffer_element.fadeOut();
		}
	});
	//used for updating social scroll when the screen has changed size
	var rtime;
	var timeout = false;
	var delta = 200;
	$(window).resize(function() {
	    rtime = new Date();
	    if (timeout === false) {
	        timeout = true;
	        setTimeout(screenResizeEnd, delta);
	    }
	});
	function screenResizeEnd() {
	    if (new Date() - rtime < delta) {
	        setTimeout(screenResizeEnd, delta);
	    } else {
	        timeout = false;
	        adjustSocialMediaContainerWidth();
	    }               
	}
	
}); //end document.ready

// Error message.
function errorMessage(err_msg) {
	var msg;	
	msg = "<p>" + err_msg + "</p><p>It looks like there is a problem retrieving this data.</p><p>Please try refreshing your browser or revisit later.</p><p>You can also report this by <a href='mailto:digitalpresence@flinders.edu.au'>sending us an email</a>.</p>";	
	$('.error_msg').html(msg).css("visibility", "visible");	
}


// AjaxErrorHandler
function ajaxErrorHandler(jqXHR, textStatus, exception, errorThrown) {
	var error_msg;
	if (jqXHR.status === 0) {
		error_msg = 'No connection.\n Verify Network.';
    } else if (jqXHR.status == 404) {
    	error_msg = '404 Requested page not found.';
    } else if (jqXHR.status == 500) {
    	error_msg = '500 Internal Server Error.';
    } else if (textStatus === 'parsererror') {
    	error_msg = 'Requested JSON parse failed.';
    } else if (textStatus === 'timeout') {
    	error_msg = 'Time out error.';
    } else if (textStatus === 'abort') {
    	error_msg = 'Ajax request aborted.';
    } else {
    	error_msg = 'Uncaught Error.\n' + jqXHR.responseText;
    }
	errorMessage(error_msg);
}

function adjustWidthForTabContainer() {	
	var staff_profile_nav_tab = $("#staffProfileTab");
	var all_spp_nav_tabs = staff_profile_nav_tab.find(".nav-item");
	var total_tab_continer_width = 0;
	
	all_spp_nav_tabs.each(function() {
		var $guardedEl_this = $(this);
		if ($guardedEl_this.length) {
		    var current_nav_item_width = $guardedEl_this.width();
		} else {
		    console.warn('guard-jquery-calls: $(this) not found, skipping.');
		}
		total_tab_continer_width += current_nav_item_width;
	});
	staff_profile_nav_tab.width(total_tab_continer_width);
	
	return total_tab_continer_width;
}
function adjustSocialMediaContainerWidth() {	
	var social_media_container = $(".social_media_container");
	var social_media_container_width = social_media_container.width();
	var social_media_list = social_media_container.find('.social_media_list');
	var all_social_media_list_items = social_media_container.find('.social_media_item');
	var social_border_width = 1;
	var calculated_social_media_list_width = social_border_width; //1px for first left border.
	var right_block = social_media_container.find('.right_block');
	
	all_social_media_list_items.each(function() {
		var $guardedEl_this = $(this);
		if ($guardedEl_this.length) {
		    var current_social_item_width = $guardedEl_this.width();
		} else {
		    console.warn('guard-jquery-calls: $(this) not found, skipping.');
		}
		calculated_social_media_list_width += (current_social_item_width + social_border_width);
	});
	social_media_list.width(calculated_social_media_list_width);
	//Set the max scroll value
	max_social_scroll_value = social_media_list.width() - social_media_container_width;
	
	if(calculated_social_media_list_width > social_media_container_width) {
		right_social_buffer_is_shown = true;
		right_block.fadeIn();
	} else {
		right_social_buffer_is_shown = false;
		right_block.fadeOut();
	}
	
	return calculated_social_media_list_width;
}

function scrollSocialMediaListOneTick(direction) {		
	var social_container = $(".social_media_container");
	var left_block = social_container.find('.left_block');
	var right_block = social_container.find('.right_block');
	
	if(direction === "left") {
		social_container.animate( { scrollLeft: '-='+social_tick_size }, 300);
//		left_block.fadeIn();
	}
	else {
		social_container.animate( { scrollLeft: '+='+social_tick_size }, 300);
//		right_block.fadeIn();
	}
		
	return social_container.scrollLeft();
}

function setSocialTickSize(size) {
	social_tick_size = size;
	return size;
}
